import { Button, DialogActions, DialogContent } from '@mui/material';
import AppDialog from './AppDialog';
import { APP_LABELS } from '../utils/labels';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmDeleteDialog({ open, onClose, onConfirm }: ConfirmDeleteDialogProps) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={APP_LABELS.confirmDeleteTitle}
      fullScreenOnMobile={false}
      maxWidth="xs"
      fullWidth
      testId="confirm-delete-dialog"
    >
      <DialogContent>
        <p className="text-sm text-text-secondary mt-0 mb-0">{APP_LABELS.confirmDeleteMessage}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" data-testid="cancel-button">{APP_LABELS.confirmDeleteCancel}</Button>
        <Button onClick={onConfirm} color="error" variant="contained" data-testid="confirm-delete-button">{APP_LABELS.confirmDeleteConfirm}</Button>
      </DialogActions>
    </AppDialog>
  );
}
